import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAllMeetingEvidences } from '../../API/apiService';
import Loader from '../../components/loader';
import { IncidenceEvidenceCollection } from '../reviewerEvidenceBrowser';
import '../reviewerEvidenceBrowser/style.scss';

export default function ReviewerIncidenceEvidences() {
  const location = useLocation();
  const targetActionId = location.state?.evidenceTarget?.incidenceActionId;
  const [actions, setActions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    getAllMeetingEvidences()
      .then(records => {
        if (!active) return;
        setActions((Array.isArray(records) ? records : [])
          .filter(record => record?.sourceType === 'incidence_action')
          .sort((first, second) =>
            String(second?.meetingDate || '').localeCompare(String(first?.meetingDate || ''))
          ));
      })
      .catch(() => {
        if (active) setError('No fue posible cargar las evidencias de acciones de incidencia.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, []);

  function updateReviewedAction(updatedAction) {
    if (!updatedAction) return;
    setActions(current => current.map(action =>
      Number(action.id) === Number(updatedAction.id)
        ? {...action, ...updatedAction, sourceType: 'incidence_action'}
        : action
    ));
  }

  return (
    <section className='reviewer-evidence'>
      <header className='reviewer-evidence__topbar'>
        <Link to='/revisor' className='reviewer-evidence__back'>
          <span className='material-symbols-rounded'>arrow_back</span>
          Centro de revisión
        </Link>
        <div>
          <span className='material-symbols-rounded'>crisis_alert</span>
          <span>Evidencias de incidencia</span>
        </div>
      </header>

      <div className='reviewer-evidence__shell'>
        <div className='reviewer-evidence__heading'>
          <div>
            <span className='reviewer-evidence__eyebrow'>ACCIONES DE INCIDENCIA</span>
            <h1>Revisión de evidencias de incidencia</h1>
            <p>
              Consulta y valida las bitácoras, fichas metodológicas y asistencias
              registradas para cada acción.
            </p>
          </div>
          <span className='reviewer-evidence__read-only'>
            <span className='material-symbols-rounded'>fact_check</span>
            Revisión y seguimiento
          </span>
        </div>

        {loading && <div className='reviewer-evidence__loading'><Loader /></div>}
        {!loading && error && <div className='reviewer-evidence__empty-small'>{error}</div>}
        {!loading && !error && (
          <IncidenceEvidenceCollection
            items={actions}
            targetActionId={targetActionId}
            onReviewUpdated={updateReviewedAction}
          />
        )}
      </div>
    </section>
  );
}
